// ── Stock Counter — urgency countdown ──
document.addEventListener('DOMContentLoaded', function () {
  const stockCounter     = document.getElementById('stock-counter');
  const stockProgressBar = document.getElementById('stock-progress-bar');

  if (!stockCounter || !stockProgressBar) return;

  const totalStock = 100;
  let   current    = 15;

  stockProgressBar.style.background  = '#dc3545';
  stockProgressBar.style.transition  = 'width 0.4s ease-out';
  stockCounter.style.fontWeight      = 'bold';

  function render() {
    stockCounter.textContent = current;
    const soldPct = ((totalStock - current) / totalStock) * 100;
    stockProgressBar.style.width = soldPct + '%';
  }

  render();

  function countdown() {
    if (current <= 7) return;

    current--;
    render();

    let nextDelay;

    if (current > 8) {
      // steady drops ~2 s each (1.8 – 2.4 s)
      nextDelay = Math.random() * 600 + 1800;
    } else if (current === 8) {
      // dramatic pause on 8: 5 – 8 s
      nextDelay = Math.random() * 3000 + 5000;
    } else {
      // slow final drip to 7: 4 – 7 s
      nextDelay = Math.random() * 3000 + 4000;
    }

    setTimeout(countdown, nextDelay);
  }

  setTimeout(countdown, 1500);
});